import { Component } from '@angular/core';

@Component({
    templateUrl: './currentbid-help.component.html',
    standalone: false
})
export class CurrentBidHelpComponent { }
